import React from "react";
import {
  WbEventHandlerMixins,
  WbMarkdownHtml,
  registerQuickAddAutoComplete,
  quickAddEventHandler,
  removeEmojiContent,
  getUserId,
  getWsTagId
} from "../../utils/common";

import { autoResizeTextArea } from "./commonTags";

// Topic relation takeaway textarea edit
class PostTakeEditText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "take",
      tag: 0,
      act: "edit",
      showDoneBtn: 0,
      pointerEvents: 'unset'
    };
    this.saveEditedTake = this.saveEditedTake.bind(this);
    this.updateTake = this.updateTake.bind(this);
    this.submitUpdatedTake = this.submitUpdatedTake.bind(this);
    this.afterUpdate = this.afterUpdate.bind(this);
    this.disableEditor = this.disableEditor.bind(this);
    this.liveSyncTakeEdit = this.liveSyncTakeEdit.bind(this);
    this.closeTextAreaField = this.closeTextAreaField.bind(this);
    this.selectArea = this.selectArea.bind(this);
    this.wrapperRef = React.createRef();
    this.handleCloseWindow = this.handleCloseWindow.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    const { take, userPermission, meetingObj } = this.props;
    if (
      typeof userPermission.execute !== "undefined" &&
      userPermission.execute == "1" &&
      take.ai_id == null
    ) {
      registerQuickAddAutoComplete(`#meeting_take_${meetingObj.id}_${take.id}`);
    }
    this.setState({
      showDoneBtn: 1
    });
    const eleId = this.getEleId();
    if (typeof eleId != 'undefined' && eleId) {
      initializeMeetingEditor(eleId, this.updateTake);
    }
    // autoResizeTextArea({ eleId: `#${eleId}` });
    // window.addEventListener("mouseup", this.saveEditedTake, true);
    WbEventHandlerMixins.placeCaretAtEnd($(`#${eleId}`).get(0));

    window.addEventListener('beforeunload', this.handleCloseWindow)
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleCloseWindow)
    document.removeEventListener('mousedown', this.handleClickOutside);
    //window.removeEventListener("mouseup", this.saveEditedTake, true);
  }

  handleCloseWindow(e) {
    const { meetingObj, take } = this.props
    const { id: meetingId } = meetingObj
    const { id: takeawayId, description } = take

    const previousTakeawayText = description

    const eleId = `meeting_take_${meetingId}_${takeawayId}`
    const takeawayCKEditorInputValue = $(`#cke_${eleId} iframe`).contents().find('body').html()
    const newTakeawayText = $(takeawayCKEditorInputValue).text().trim()

    if (previousTakeawayText !== newTakeawayText) {
      e.preventDefault()
      e.returnValue = ''
    }
  }

  handleClickOutside(event) {
    const { take, meetingObj } = this.props;
    const id = `meeting_take_${meetingObj.id}_${take.id}`;
    const linkPopup = $(`.cke_editor_${id}_dialog`);
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target) && (linkPopup.length == 0 || (linkPopup.length > 0 && linkPopup.css('display') == 'none'))) {
      this.updateTake();
      if ($('.mention-suggestions').length > 0 && $(event.currentTarget.activeElement).parents('.cke').length < 1) {
        $('.mention-suggestions').remove();
        $('.mention-suggestions-div').remove();
      }
    }
  }

  getEleId = () => {
    return `meeting_take_${this.props.meetingObj.id}_${this.props.take.id}`;
  }

  saveEditedTake(e) {
    const { take, meetingObj } = this.props;
    const empTakeContainer = $(`#meeting_take_${meetingObj.id}_${take.id}`);
    const agendaSearchContainer = $(".agenda-autosearch");
    const tagListContainer = $(".meeting-tag-wrapper");

    // but adding a more reliable way to track click vs drag (mousedown/mouseup)
    let highlightedText = "";
    if (window.getSelection) {
      highlightedText = window.getSelection().toString();
    } else if (document.selection && document.selection.type != "Control") {
      highlightedText = document.selection.createRange().text;
    }
    if (highlightedText != "") {
      return;
    } else {
      if (
        !$(empTakeContainer).is(e.target) &&
        $(empTakeContainer).has(e.target).length === 0 &&
        (!$(agendaSearchContainer).is(e.target) &&
          $(agendaSearchContainer).has(e.target).length === 0) &&
        (!$(tagListContainer).is(e.target) &&
          $(tagListContainer).has(e.target).length === 0)
      ) {
        const fieldObj = $(this.refs.meeting_take);
        const editedTake = removeEmojiContent($.trim($(fieldObj).html()));
        if (editedTake == "" || editedTake == null || typeof editedTake === 'undefined') {
          return;
        }
        if (editedTake === "<br>") {
          return;
        }

        this.submitUpdatedTake(editedTake);
      }
    }
  }

  updateTake(e) {
    this.setState({
      pointerEvents: 'none'
    })
    const { take, meetingObj } = this.props;
    autoResizeTextArea({ eleId: `#meeting_take_${+meetingObj.id}_${take.id}` });
    let takeawayCKEditorInput = $(`#cke_meeting_take_${+meetingObj.id}_${take.id}`);
    if (takeawayCKEditorInput != undefined) {
      let takeawayCKEditorInputValue = $(`#cke_meeting_take_${+meetingObj.id}_${take.id}` + ' iframe').contents().find('body').html();
      if ($(takeawayCKEditorInputValue).text() == '') {
        takeawayCKEditorInputValue = '';
      }
      $(`#meeting_take_${+meetingObj.id}_${take.id}`).val(takeawayCKEditorInputValue);
    }
    const fieldObj = $(this.refs.meeting_take);
    let subActText = $.trim($(fieldObj).val());
    const quickAddAI = $(fieldObj).data("quickAddAI");

    // if (
    //   ((e.keyCode == 13 && quickAddAI == true) ||
    //     ((e.ctrlKey || e.metaKey) && e.keyCode == 83)) &&
    //   subActText != ""
    // ) {
    //   e.preventDefault();
    if (subActText == "") {
      subActText = $(fieldObj).html();
      // return;
    }

    this.submitUpdatedTake(subActText);
    // }
  }

  submitUpdatedTake(editedTakeText, updatedS3Data) {
    const { meetingObj } = this.props;
    const { actions } = this.props;
    const meetingId = meetingObj.id;
    const { take } = this.props;
    const takeId = take.id;
    const fname = take.firstname;
    const lname = take.lastname;
    const tagId = take.tag;
    const { topicId } = this.props;

    const fieldObj = $(`#meeting_take_${meetingId}_${takeId}`);
    if (fieldObj.parents(".meeting_take_sortable").length) {
      fieldObj.parents(".meeting_take_sortable").removeClass("bgwhite");
    }
    let quickAddAI = true; //$(fieldObj).data("quickAddAI");
    if (editedTakeText.length == 0 || $('#cke_meeting_take_' + meetingId + '_' + takeId + ' iframe').contents().find('body').text() == '') {
      this.disableEditor(takeId);
      return false;
    }
    if (
      quickAddAI == true &&
      !editedTakeText.match(/#(.*)#/) &&
      !editedTakeText.match(/@(.*)@/) &&
      !editedTakeText.match(/(\!)(\d)+(\?)*/g)
    ) {
      quickAddAI = false;
    }
    if (quickAddAI == true && editedTakeText.match(/@(.*)@/) && !editedTakeText.match('data-userid')) {
      quickAddAI = false;
    }
    if (quickAddAI == true && editedTakeText.match(/#(.*)#/) && !editedTakeText.match('data-quickaddtagid')) {
      quickAddAI = false;
    }
    const meetingWsId = meetingObj.ws_id;
    const quickAddAIParams = {};
    if (quickAddAI == true) {
      const isvalid = quickAddEventHandler(fieldObj);
      if (!isvalid) {
        return;
      }
      quickAddAIParams.tagId = getWsTagId(editedTakeText);
      if (
        quickAddAIParams.tagId == "" ||
        typeof quickAddAIParams.tagId === "undefined"
      ) {
        quickAddAIParams.tagId = meetingWsId;
      }
      quickAddAIParams.userId = getUserId(editedTakeText);
    }

    if (updatedS3Data) {
      actions.UpdateMeetingS3Data("mtS3Data", updatedS3Data);
    }

    this.props.updateTopicTake(
      editedTakeText,
      meetingId,
      topicId,
      tagId,
      fname,
      lname,
      this.state.type,
      takeId,
      quickAddAI,
      quickAddAIParams,
      this.afterUpdate
    );
  }

  afterUpdate(subActText, topicId) {
    this.setState({
      tag: 0,
      showDoneBtn: 0,
      pointerEvents: 'unset'
    });
    this.disableEditor(topicId);
  }

  disableEditor(id) {
    this.props.disableTakeText(id);
  }

  liveSyncTakeEdit() {
    // Notify typing event
    if (!getMeetingTyping()) {
      typing("meet");
      setMeetingTyping(true);
    } else {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        typingTimeOut("meet");
      }, 3500);
    }
    // if user is typing and both the users are active in meeting, then display the warning
    if ($("#typing-alert").css("display") == "none") {
      // element is hidden
      $(".topic-alert")
        .delay(100)
        .fadeOut();
    } else {
      $(".topic-alert")
        .delay(500)
        .fadeIn();
    }
  }

  closeTextAreaField(id) {
    this.props.disableTakeText(id);

    this.setState({
      showDoneBtn: 0
    });
  }

  selectArea(e, id) {
    e.preventDefault();

    const { meetingObj, take } = this.props;
    const eleId = `meeting_take_${meetingObj.id}_${take.id}`;
    autoResizeTextArea({ eleId: `#${eleId}` });
  }

  render() {
    const { meetingObj } = this.props;
    const { take } = this.props;
    const takeId = take.id;
    const { topicId } = this.props;
    const color = "#FFFFFF";

    let takeDesc = this.props.take.description;
    takeDesc = takeDesc.replaceAll('<strong style="font-weight: bold">', '<strong>')
      .replaceAll('<strong style="font-weight:bold">', '<strong>')
      .replaceAll('<span style="font-style: italic">', '<span>')
      .replaceAll('<span style="font-style:italic">', '<span>')

    return (
      <div
        className="wb-table-col clickable-text wb-table-col-edit-title editTakeTextArea dispBk width100"
        style={{ backgroundColor: color }}
      >
        <div className="textAlignLeft width100" ref={this.wrapperRef}>
          <div
            // contentEditable="true"
            data-enable-quickadd="true"
            className="meetingagendatextbox takeEditContainer"
            id={`meeting_take_${meetingObj.id}_${takeId}`}
            placeholder=""
            onKeyDown={event => this.updateTake(event)}
            ref="meeting_take"
            onKeyPress={event => this.liveSyncTakeEdit(event)}
            onClick={e => this.selectArea(e, topicId)}
            dangerouslySetInnerHTML={WbMarkdownHtml(
              takeDesc,
              true
            )}
          />
          {this.state.showDoneBtn ? (
            <button
              onClick={e => this.updateTake(e)}
              className="btn-circle subTakeBtn"
              style={{ marginTop: "-41px", pointerEvents: this.state.pointerEvents }}
            >
              <span className="icon icon-outline-check-24px-blue"></span>
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
export default PostTakeEditText;
